/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      projectName
      identificationNumber
      abstract
      uploadAbstract
      startDate
      endDate
      projectType
      isDeleted
      status
      username
      lowerCaseName
      projectFiles {
        items {
          id
          project_id
          fileDescription
          fileLink
          username
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      projectComments {
        items {
          id
          project_id
          fileComment
          username
          createdDate
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      projectName
      identificationNumber
      abstract
      uploadAbstract
      startDate
      endDate
      projectType
      isDeleted
      status
      username
      lowerCaseName
      projectFiles {
        items {
          id
          project_id
          fileDescription
          fileLink
          username
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      projectComments {
        items {
          id
          project_id
          fileComment
          username
          createdDate
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      projectName
      identificationNumber
      abstract
      uploadAbstract
      startDate
      endDate
      projectType
      isDeleted
      status
      username
      lowerCaseName
      projectFiles {
        items {
          id
          project_id
          fileDescription
          fileLink
          username
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      projectComments {
        items {
          id
          project_id
          fileComment
          username
          createdDate
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createProjectFile = /* GraphQL */ `
  mutation CreateProjectFile(
    $input: CreateProjectFileInput!
    $condition: ModelProjectFileConditionInput
  ) {
    createProjectFile(input: $input, condition: $condition) {
      id
      project_id
      fileDescription
      fileLink
      username
      isDeleted
      project {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProjectFile = /* GraphQL */ `
  mutation UpdateProjectFile(
    $input: UpdateProjectFileInput!
    $condition: ModelProjectFileConditionInput
  ) {
    updateProjectFile(input: $input, condition: $condition) {
      id
      project_id
      fileDescription
      fileLink
      username
      isDeleted
      project {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProjectFile = /* GraphQL */ `
  mutation DeleteProjectFile(
    $input: DeleteProjectFileInput!
    $condition: ModelProjectFileConditionInput
  ) {
    deleteProjectFile(input: $input, condition: $condition) {
      id
      project_id
      fileDescription
      fileLink
      username
      isDeleted
      project {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createProjectComment = /* GraphQL */ `
  mutation CreateProjectComment(
    $input: CreateProjectCommentInput!
    $condition: ModelProjectCommentConditionInput
  ) {
    createProjectComment(input: $input, condition: $condition) {
      id
      project_id
      fileComment
      username
      createdDate
      isDeleted
      project {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProjectComment = /* GraphQL */ `
  mutation UpdateProjectComment(
    $input: UpdateProjectCommentInput!
    $condition: ModelProjectCommentConditionInput
  ) {
    updateProjectComment(input: $input, condition: $condition) {
      id
      project_id
      fileComment
      username
      createdDate
      isDeleted
      project {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProjectComment = /* GraphQL */ `
  mutation DeleteProjectComment(
    $input: DeleteProjectCommentInput!
    $condition: ModelProjectCommentConditionInput
  ) {
    deleteProjectComment(input: $input, condition: $condition) {
      id
      project_id
      fileComment
      username
      createdDate
      isDeleted
      project {
        id
        projectName
        identificationNumber
        abstract
        uploadAbstract
        startDate
        endDate
        projectType
        isDeleted
        status
        username
        lowerCaseName
        projectFiles {
          nextToken
        }
        projectComments {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
